module.exports = __webpack_public_path__ + "assets/linkedin.bd67c3af.svg";